import { ServerFleet } from '@/components/global-admin/servers/ServerFleet';

export default function ServersPage() {
  return (
    <div className="space-y-6" data-testid="servers-page">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">Servers</h2>
        <p className="text-muted-foreground">
          Every Bailey this AOC knows, by customer: where it runs, which version, what it bills the customer and
          what a cloud server costs BitSwan. Each server lists releases from the channels it is subscribed to: the
          public channel, the pull-request channel, or both. A server on the pull-request channel can update to a
          pull request's release and try it before it is merged.
        </p>
      </div>
      <ServerFleet />
    </div>
  );
}
